// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__5JWYR","button":"styles_button__3RUKp"};